import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import SchoolsTable from '../../components/schools/SchoolsTable';

const Schools = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <SchoolsTable />
        </WrapperSection>
    );
};

export default Schools;
